<template>
  <button class="text-secondary"
    type="button"
    v-if="isShowingClearFilters"
    @click="clearFilters">
    Clear filters
  </button>
</template>

<script>
import get from 'lodash/get'
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['filters']),
    isShowingClearFilters () {
      return get(this.filters, ['budgets'], '') !== '' ||
        get(this.filters, ['destinations'], '') !== '' ||
        get(this.filters, ['greenfin'], '') !== '' ||
        get(this.filters, ['rating'], '') !== '' ||
        get(this.filters, ['facilities'], '') !== '' ||
        get(this.filters, ['species'], '') !== '' ||
        get(this.filters, ['tags'], '') !== ''
    }
  },
  methods: {
    clearFilters () {
      this.$store.commit('clearFilters')
      this.$store.dispatch('loadSuppliers')
    }
  }
}
</script>